import LSelect from './src/main'

/* istanbul ignore next */
LSelect.install = function(Vue) {
  Vue.component(LSelect.name, LSelect)
}

export default LSelect
